<template>
  <section
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row y-gap-15 justify-between items-center">
        <div class="col-auto">
          <h2 v-html="vars.titleHtml"></h2>
        </div>
        <div class="col-lg-6 col-md-9">
          <p>
            {{ vars.descriptionText }}
          </p>
        </div>
      </div>

      <div data-anim-wrap class="row y-gap-30 pt-60 md:pt-30">
        <div
          class="col-lg-3 col-sm-6"
          v-for="(team, index) in teams"
          :key="index"
        >
          <div
            class="teamCard -type-1"
            :data-anim-child="`slide-left delay-${index + 1}`"
          >
            <div class="teamCard__image ratio ratio-33:35">
              <img
                v-if="team.photo"
                :src="team.photo"
                :alt="team.title"
                class="img-ratio"
              />
            </div>
            <div class="mt-3">
            <h4>
              {{ team.name }}
            </h4>
          </div>
          
            <div class="mt-1">
              <h5 :style="{ color: 'var(--c-secondary)' }">
                {{ team.role }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TeamSection',

  mixins: [ComponentMixin],

  computed: {
   
    teams() {
     
      return this.groupedVariables?.teams || [];
    },
  },
});
</script>
